import { Stack } from '@mui/material';
import { CustomSkeleton } from './styles';

export const VersionsLoader = () => {
  return (
    <Stack direction="column" sx={{ height: '100%', px: 1, mt: 8, ml: 2.5 }}>
      {[...Array.from({ length: 3 }).keys()].map(() => (
        <>
          <CustomSkeleton width={70} />
          <CustomSkeleton width={120} height={24} sx={{ mt: 3 }} />
          <CustomSkeleton width={40} sx={{ mt: 0.5 }} />
          <CustomSkeleton width={80} sx={{ mt: 0.5, mb: 4 }} />
        </>
      ))}
    </Stack>
  );
};
